import Axios from 'axios';
import { empresasLead } from './bff/bffClient';
import { mapArtLead } from './bff/bffMappers';
import { getPathName, getPais, getApiHash, getApiToken } from './helper';

/**
 * Lead ART. ROUTING POR PAÍS (el BFF es Argentina-only):
 * - AR: arma el body tipado §12.2 (`mapArtLead`) y lo postea al BFF (`empresasLead`).
 * - UY: flujo LEGACY al monolito (POST {monolito}/SetCotizacionArtJSON), como en prod.
 * El país lo determina `getPais()` (dominio/REACT_APP_PAIS); el call-site puede
 * forzarlo con el arg `pais`. `captchaToken` lo usa el monolito en el body; en AR
 * lo mintea el bffClient en el header.
 * Devuelve el envelope { data: { api_status, api_data } } que consume la pantalla de gracias.
 */
const guardarContactoArt = async (origen, tipoCotizador, landingUrl, refererUrl, cuit, razonSocial, masaSalarial, empleados, email, codigoArea, telefono, provincia, localidad, nombreApellido, apellido, captchaToken, pais = getPais()) => {
    if (pais === 'UY') {
        const params = {
            hash: await getApiHash(),
            isMobile: "false",
            rubro: "ART",
            origen: origen,
            tipoCotizador: tipoCotizador,
            landingUrl: landingUrl,
            refererUrl: refererUrl,
            cuit: cuit,
            razonSocial: razonSocial,
            empleados: empleados,
            masaSalarial: masaSalarial,
            nombreApellido: nombreApellido,
            apellido: apellido,
            email: email,
            codigoArea: codigoArea,
            telefono: telefono,
            provincia: provincia,
            localidad: localidad,
            g_recaptcha_response: captchaToken,
        };
        const headers = {
            'content-type': 'application/json',
            "Authorization": 'Bearer ' + await getApiToken(),
        };
        return await Axios.post(await getPathName() + "/SetCotizacionArtJSON", params, { headers })
            .then((response) => response)
            .catch((error) => error);
    }

    const body = mapArtLead({
        origen,
        tipoCotizador,
        landingUrl: landingUrl ?? (typeof window !== 'undefined' ? window.location.href : undefined),
        refererUrl,
        cuit,
        razonSocial,
        masaSalarial,
        empleados,
        email,
        codigoArea,
        telefono,
        provincia,
        localidad,
        nombre: nombreApellido,
        apellido,
    });

    try {
        const apiData = await empresasLead(body);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
};

export default guardarContactoArt;
